<template>
  <div id="search-form">
    <form @submit.prevent class="container d-flex flex-column">
      <div class="row mb-3">
        <fieldset class="search col-md-3">
          <legend>{{$t('form.search.legend')}}</legend>
          <ncs-multi-select field="ncs_documents.subcorpus"/>
          <ncs-search-type/>
        </fieldset>
        <fieldset class="result col-md-9">
          <legend>{{$t('form.result.legend')}}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-result-type/>
            </div>
            <div class="col-md-6">
              <ncs-order-selector/>
            </div>
            <div class="col-md-3">
              <ncs-page-size-selector/>
            </div>
            <div class="col-md-6 offset-md-3">
              <ncs-matching-expressions-group-selector/>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="row mb-3">
        <fieldset class="sensibility col-md-3">
          <legend>{{$t('form.sensibility.legend')}}</legend>
          <ncs-global-option-checkbox name="ncs_accent" :value="false"/>
          <ncs-global-option-checkbox name="case" :value="false"/>
          <ncs-global-option-checkbox name="ncs_greek_compound" :value="false"/>
        </fieldset>
        <fieldset class="filters col-md-9">
          <legend>{{$t('form.filters.legend')}}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-select field="ncs_documents.text_genre" :dependencies="['ncs_documents.subcorpus']"/>
            </div>
            <div class="col-md-6">
              <ncs-select field="ncs_documents.text_subgenre" :dependencies="['ncs_documents.text_genre', 'ncs_documents.subcorpus']"/>
            </div>
            <div class="col-md-3">
              <ncs-select field="ncs_documents.specialization" :dependencies="['ncs_documents.text_genre', 'ncs_documents.subcorpus']"/>
            </div>
            <div class="col-md-3">
              <ncs-select field="ncs_documents.parallel" :dependencies="['ncs_documents.subcorpus', 'ncs_documents.text_genre']"/>
            </div>
            <div class="col-md-3">
              <ncs-select field="ncs_documents.language" :dependencies="['ncs_documents.subcorpus']"/>
            </div>
            <div class="col-md-3">
              <ncs-number-select-filter type="number" name="ncs_documents.year_from" field="ncs_documents.year"
                                        :first-as-any="true" :min="yearFrom" :max="yearTo" operator="gteq"/>
            </div>
            <div class="col-md-3">
              <ncs-number-select-filter type="number" name="ncs_documents.year_to" field="ncs_documents.year"
                                        :first-as-any="true " :min="yearFrom" :max="yearTo" operator="lteq"
                                        :reverse="true"/>
            </div>
          </div>
        </fieldset>
      </div>
      <ncs-element-section/>
      <div class="btn-group align-self-end mt-3">
        <ncs-download-button/>
        <ncs-back-button/>
        <ncs-reset-button/>
        <ncs-search-button/>
      </div>
    </form>
    <ncs-result>
      <ncs-frequency-result/>
      <ncs-full-frequency-result/>
      <ncs-kwic-result/>
      <ncs-matching-expressions-result/>
      <ncs-context-result/>
    </ncs-result>
  </div>
</template>
<script>
  import min from 'lodash/min'
  import max from 'lodash/max'
  import {mapGetters} from 'vuex'
  import Ncs from 'ncs'

  export default {
    extends: Ncs.defaultComponents.NcsForm,
    computed: {
      ...mapGetters('filters', ['selectedValue']),
      subcorpus() {
        return this.selectedValue('ncs_documents.subcorpus')
      },
      yearFrom() {
        if (!this.subcorpus || this.subcorpus.length === 0) {
          return gon.min_max_years.first
        } else {
          return min(this.subcorpus.map(s => gon.years_by_subcorpus[s].first))
        }
      },
      yearTo() {
        if (!this.subcorpus || this.subcorpus.length === 0) {
          return gon.min_max_years.last
        } else {
          return max(this.subcorpus.map(s => gon.years_by_subcorpus[s].last))
        }
      }
    },
    watch: {
      subcorpus() {
        this.$store.commit('filters/setFilter', {'ncs_documents.year_from': null, 'ncs_documents.year_to': null})
      }
    }
  }
</script>
<style lang="scss">
  @import "../scss/variables";

  legend {
    color: $primary;
    border-bottom: 1px solid $primary;
    font-size: 14px;
    margin-bottom: 5px;
  }

  label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
  }

  .form-group {
    margin-bottom: 0.25rem;
  }
</style>
